/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/step-forward-icon/step-forward-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=step-forward-icon.component.css.map */
